export const SITE = {
  brand: "Red Chilly's",
  tagline: "India's Street Kitchen",
  phone: "+1 (412) 312-6041",
  phoneHref: "tel:+14123126041",
  address: "5474 Campbells Run Rd, Pittsburgh, PA 15205",
  mapUrl: "https://www.google.com/maps?q=5474+Campbells+Run+Rd,+Pittsburgh,+PA+15205&output=embed",
  directions: "https://maps.google.com/?q=5474+Campbells+Run+Rd,+Pittsburgh,+PA+15205",
  hours: [
    { day: "Tuesday – Thursday", time: "11:30 AM – 2:30 PM & 5:00 PM – 10:00 PM" },
    { day: "Friday – Saturday", time: "11:30 AM – 2:30 PM & 5:00 PM – 10:30 PM" },
    { day: "Sunday", time: "11:30 AM – 2:30 PM & 5:00 PM – 10:00 PM" },
    { day: "Monday", time: "Closed" },
  ],
  social: {
    instagram: "https://instagram.com/",
    facebook: "https://facebook.com/",
    yelp: "https://yelp.com/",
  },
};

export const IMAGES = {
  heroDish:
    "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?auto=format&fit=crop&w=1400&q=85",
  heroBiryani:
    "https://images.unsplash.com/photo-1599043513900-ed6fe01d3833?auto=format&fit=crop&w=1400&q=85",
  spice1:
    "https://images.unsplash.com/photo-1611850351931-be566839b998?auto=format&fit=crop&w=400&q=80",
  spice2:
    "https://images.unsplash.com/photo-1596797038530-2c107229654b?auto=format&fit=crop&w=400&q=80",
  chili:
    "https://images.unsplash.com/photo-1583485646054-29874bc99f5e?auto=format&fit=crop&w=400&q=80",
  mint:
    "https://images.unsplash.com/photo-1628557119279-fcd5d1c83d33?auto=format&fit=crop&w=400&q=80",
  lemon:
    "https://images.unsplash.com/photo-1582287014914-1db836fd1ce8?auto=format&fit=crop&w=400&q=80",
  aboutA:
    "https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=900&q=85",
  aboutB:
    "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=900&q=85",
  lunchSpecial:
    "https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?auto=format&fit=crop&w=900&q=85",
  dinnerSpecial:
    "https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=900&q=85",
  signatureDish:
    "https://images.unsplash.com/photo-1701579231349-d7459c40919d?auto=format&fit=crop&w=900&q=85",
  signatureBiryani:
    "https://images.unsplash.com/photo-1633945274405-b6c8069047b0?auto=format&fit=crop&w=1400&q=85",
  gallery: [
    "https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=900&q=85",
    "https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?auto=format&fit=crop&w=900&q=85",
    "https://images.unsplash.com/photo-1565557623262-b51c2513a641?auto=format&fit=crop&w=900&q=85",
    "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?auto=format&fit=crop&w=900&q=85",
    "https://images.unsplash.com/photo-1668236543090-82eba5ee5976?auto=format&fit=crop&w=900&q=85",
    "https://images.unsplash.com/photo-1589301773859-bb024d3ad558?auto=format&fit=crop&w=900&q=85",
    "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?auto=format&fit=crop&w=900&q=85",
    "https://images.unsplash.com/photo-1610192244261-3f33de3f55e4?auto=format&fit=crop&w=900&q=85",
    "https://images.unsplash.com/photo-1505253758473-96b7015fcd40?auto=format&fit=crop&w=900&q=85",
  ],
};

export const TESTIMONIALS = [
  {
    quote:
      "The Hyderabadi 65 is unreal — crackling outside, juicy inside. Every bite tastes like a Saturday night on Charminar Road.",
    name: "Aarav P.",
    role: "Regular since 2022",
  },
  {
    quote:
      "We drove 40 minutes for the special chicken biryani and we'd do it again tomorrow. Layered, smoky, and unforgettable.",
    name: "Priya & Raj",
    role: "Family of four",
  },
  {
    quote:
      "Finally a place in Pittsburgh that gets the dosa right. Crisp edges, soft middle, gun-powder that actually hits.",
    name: "Mark D.",
    role: "Food critic, local blog",
  },
  {
    quote:
      "The owners treat you like extended family. Warm service, generous portions, real Indian flavour — no shortcuts.",
    name: "Neha S.",
    role: "Yelp Elite",
  },
];

export const SPECIALS = [
  {
    title: "Lunch Special",
    blurb: "Quick, hot, generous. Built for your midday escape.",
    image: "lunchSpecial",
    badge: "11:30 – 2:30",
  },
  {
    title: "Dinner Special",
    blurb: "Slow-cooked curries, smoky kebabs, golden naan.",
    image: "dinnerSpecial",
    badge: "5:00 – 10:00",
  },
  {
    title: "Signature Dish",
    blurb: "Red Chilly's Special Biryani — dum-cooked, family secret.",
    image: "signatureDish",
    badge: "House Favourite",
  },
];
